<template>
  <div class="layout-footer">
    <span class="font-medium text-lg text-muted-color">PrimeVue Ultima</span>
    <div class="flex gap-2">
      <Button icon="pi pi-github" rounded variant="text" severity="secondary" />
      <Button icon="pi pi-facebook" rounded variant="text" severity="secondary" />
      <Button icon="pi pi-twitter" rounded variant="text" severity="secondary" />
    </div>
  </div>
</template>
